import React, { useEffect } from "react";
import styled from "styled-components";
import LeftRailOption from "./LeftRailOption";

interface Props {
	language: string;
	latestStep: string;
	handleNextLocation?: any;
}

const LeftRail = ({
	language,
	latestStep,
	handleNextLocation
}: Props) => {
	const stepOrder = ["SALES", "SALES_SUMMARY", "REWARDS", "REVIEW", "SUBMITTED"];
	const handleDisabled = (stepId: string) => {
		const stepIdIndex = stepOrder.indexOf(stepId);
		const latestStepIndex = stepOrder.indexOf(latestStep);
		if (stepIdIndex <= latestStepIndex) { // not disabled
			return false;
		}
		return true;
	}

	// scroll to top of page on left rail/page reload
	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
	}, [])
	
	return (
		<Wrapper>
			<LeftRailOption
				label={language === "en" ? "1. Sales" : "1. Ventes"}
				nextLocation="/financial-form/sales"
				disabled={handleDisabled("SALES")}				
				handleNextLocation={handleNextLocation}
			/>
			<LeftRailOption 
				label={language === "en" ? "2. Sales Summary" : "2. Sommaire des ventes"}
				nextLocation="/financial-form/sales-summary"
				disabled={handleDisabled("SALES_SUMMARY")}				
				handleNextLocation={handleNextLocation}
			/>
			<LeftRailOption 
				label={language === "en" ? "3. Rewards" : "3. Récompenses"}
				nextLocation="/financial-form/rewards"
				disabled={handleDisabled("REWARDS")}
				handleNextLocation={handleNextLocation}
			/>
			<LeftRailOption 
				label={language === "en" ? "4. Review" : "4. Révision"}
				nextLocation="/financial-form/review"
				disabled={handleDisabled("REVIEW")}				
				handleNextLocation={handleNextLocation}
			/>
		</Wrapper>
	);
};

export default LeftRail;

const Wrapper = styled.div`
	box-sizing: border-box;
	position: absolute;
	margin-top: 70px;
	left: 100px;
	width: 150px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 19px;
	@media (max-width: 1080px) {
		margin-top: 0;
		left: 0;
		width: 100%;
		justify-content: center;
		flex-direction: row;
		padding: 24px 40px;
		white-space: nowrap;
		overflow: auto hidden;
		scrollbar-width: none;
	}
	@media (max-width: 520px) {
		justify-content: space-between;
	}
`;
